PJQ.views.dailyReports.AttachmentManagement = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Attachment-Management')
	},
	events: {
		'click .daily-report-attachment': 'attachmentClicked'
	},
	beforeRender: function () {
		this.options.isLocked = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DAILY_REPORT_IS_LOCKED_AFTER_SUBMIT) && this.model.get('status') === 1;
		this.options.isAdmin = this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
			&& this.options.project.hasPermission('dailyReports.isAdminAttachments');
		this.options.canEdit = this.model.isNew() || (this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
			&& this.options.project.hasPermission('dailyReports.canAddAttachments') && !this.options.isLocked);
	},
	afterRender: function () {
		this.fileUploader = new PJQ.views.files.FileUploaderGrid({
			el: this.$('.daily-report-attachment-uploader'),
			endpoint: this.model.endpoint() + '/attachments',
			collection: this.model.attachments,
			// includeProjectAttachments: true,
			canUpload: this.options.canEdit,
			canDelete: this.options.isAdmin && this.options.canEdit,
			onSuccess: _.bind(function(file) {
				new PJQ.ajax.Request({
					endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
						{
							endpoint: 'dailyreports',
							value: this.model.id
						},
						{
							endpoint: 'attachments'
						}
					]),
					data: file,
				}).put().done(_.bind(function (file) {
				}, this)).fail(onScriptError);
			}, this),
			onDelete: function (file, callback) {
				new PJQ.views.modals.DeleteCancel({
					header: "Confirm Deletion",
					body: "Are you sure you want to delete this attachment?",
					onDelete: _.bind(function () {
						file.destroy();
						callback();
					}, this)
				});
			}
		});
	},
	attachmentClicked: function (e) {
		let selectedAttachment = this.model.attachments.get($(e.currentTarget).data('cid'));
		this.viewAttachment(selectedAttachment);
	},
	viewAttachment: function (attachment) {
		PJQ.app.view.renderPhotoViewer({
			model: attachment
		});
	}
});
